import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 11 8",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1 3.506a1 1 0 0 0-.707.293 1 1 0 0 0 0 1.414l2.385 2.385a1 1 0 0 0 1.416 0 1 1 0 0 0 0-1.414L1.707 3.799A1 1 0 0 0 1 3.506z" }, null, -1),
    _createElementVNode("path", { d: "M9.185.11a1 1 0 0 0-.707.29L2.68 6.184a1 1 0 0 0-.002 1.414 1 1 0 0 0 1.414.002L9.89 1.816A1 1 0 0 0 9.893.402 1 1 0 0 0 9.186.11z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "check"}) } }